import { useEffect, useState } from "react";
import UseGetData from "../../../../Components/Hooks/useFetchData";
import SearchBar from "../../../../Components/Utils/SearchBar";
import {
  CancelButton,
  CreateButton,
  FilterButton,
  SubmitButton,
} from "../../../../Components/Utils/Buttons";
import DataTable from "../../../../Components/Others/DataTable";
import { Link, useLocation, useParams } from "react-router-dom";
import Breadcrumb from "../../../../Components/Utils/Breadcrumb";
import MoreOptions from "../../../../Components/Utils/MoreOptions";
import CustomDataTable from "../../../../Components/Others/CustomDataTable";
import { useFormik } from "formik";
import * as yup from 'yup';
import UseGetDataSearch from "../../../../Components/Hooks/useFetchDataBySearch";
import FormikSelectTwo from "../../../../Components/Utils/Select";
import useFetchMataData from "../../../../Components/Hooks/useFetchMataData";
import UseCatSubCatDropDown from "../../../../Components/Hooks/useCategoryDropDown";
import ModalContainer from "../../../../Components/Others/ModalContainer";
import MultiEditRequest from "./MultiEditRequest";
import { GetAccess } from "../../../../Components/Utils/roles";
import useFetchMDIndex from "../../../../Components/Hooks/useFetchMDIndex";
import StoreLayout from "../StoreLayout";
import { useNumber } from "../../../../Context/ProjectIdContext";
import UseDropDown from "../../../../Components/Hooks/useDropDown";
import UseDropDownAP from "../../../../Components/Hooks/UseApprovalDD";
import MobileIndex from "../../../Mobile/Store/Request/MobileIndex";

function RequestIndex() {
  const [screenSize, setScreenSize] = useState({
    width: window.innerWidth,
  });

  useEffect(() => {
    const handleResize = () => {
      setScreenSize({
        width: window.innerWidth,
      });
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  const {officeId} =useParams();
  const {number} = useNumber()

  const location = useLocation
  ();
  const currentPage= location.state?.currentPage
  const searchQuery= location.state?.searchQuery
  const [page, setPage] = useState(currentPage||1)
  const [pageCount, setPageCount] = useState(localStorage.getItem("perPageView")||20)
  const [filter, setFilter] = useState(false);
  const [showFilterDialog, setShowFilterDialog] = useState(false);
   const {value:RequestStatus,getData:refRequestStatus} = useFetchMataData(`/dropdown/dropdown-details/`,'RequestStatus',showFilterDialog)
   const { data: ApprovalStatus, getData: getApprovalStatus } = UseDropDownAP(
    "/approval-status/drop-down/by-module/request"
  );
  const [filterProps, setFilterProps] = useState({
   status:"",
approvalStatus:"",
isReturnable:""
  });
  const [params, setParams] = useState({
    page: page,
    per_page: pageCount,
    search:searchQuery||"",

   status:"",
approvalStatus:"",
isReturnable:""
  });

  const clearFilter = ()=> {
    setParams({...params,  status:"",
      approvalStatus:"",
      isReturnable:""})
      setFilter(false)
      formik.values.status=""
      formik.values.approvalStatus=""
      formik.values.isReturnable=""
      
  }

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: filterProps,
    validateOnChange: false,
    validateOnBlur: false,
    validationSchema: yup.object({
      // email: yup.string().required('Email is required!'),
    }),
    onSubmit: async (value, { resetForm }) => {
      console.log("ffff",value);
      setParams({...params,isReturnable:value.isReturnable,approvalStatus:value.approvalStatus,status:value.status})
      closeFilterDialog();
      setFilter(true)
      setFilterProps({
       
        isReturnable:"",
        approvalStatus:"",
       
        status:""
      });
    }
  })

  const { data, totalCount, getData ,dataLoading} = UseGetDataSearch(`/requests/${number}/project`,params );

  const defaultHeaders = [
    {
      title: "Request No.",
      width: "5%",
      field: "ref",
      isLink: true,
      id: "requestId",
      link: `/main/${officeId}/store/requests/view/`,
 
      textAlign: "center",
      rowAlign: "center",
    },
   
    {
      title: "Request For",
      width: "10%",
      isLink: true,
      id: "requestId",
      link: `/main/${officeId}/store/requests/view/`,
      field: "requestFor",
      textAlign: "center",
      rowAlign: "center",
    },
    {
      title: "Purpose",
      width: "10%",
      field: "purpose",
      textAlign: "center",
      rowAlign: "center",
    },
    {
      title: "Is Returnable",
      width: "10%",
      field: "isReturnable",
      isCondition: true,
      textAlign: "center",
      rowAlign: "center",
    },
    {
      title: "Issueed By",
      width: "10%",
      field: "issueedByName",
      textAlign: "center",
      rowAlign: "center",
    },
    {
      title: "Status",
      width: "10%",
      field: "status",
      textAlign: "center",
      rowAlign: "center",
    },
    
    // {
    //   title: "Comments",
    //   width: "10%",
    //   field: "comments",
    //   textAlign: "center",
    //   rowAlign: "center",
    // },
    {
      title: "Action",
      width: "5%",
      field: "action",
      textAlign: "center",
      rowAlign: "center",
      contents:{
        // fetcher:getData,
        id:"requestId",
        removeValue:"requestFor",
        url:`/requests/`,
        moduleName:"Requests",
        from:`/main/${officeId}/store/requests`,
        editLink:`/main/${officeId}/store/requests/edit/`,
        viewLink:`/main/${officeId}/store/requests/view/`
      }
    },
  ];
  const availableHeaders = [
    {
      title: "ID",
      width: "5%",
      field: "requestId",
      textAlign: "center",
      rowAlign: "center",
    },
    {
      title: "Item",
      width: "10%",
      isLink: true,
      id: "requestId",
      link: `/main/${officeId}/store/requests/view/`,
   
      field: "itemName",
      textAlign: "center",
      rowAlign: "center",
    },
    {
      title: "Request For",
      width: "10%",
      isLink: true,
      id: "requestId",
      link: `/main/${officeId}/store/requests/view/`,
      field: "requestFor",
      textAlign: "center",
      rowAlign: "center",
    },
    {
      title: "Purpose",
      width: "10%",
      field: "purpose",
      textAlign: "center",
      rowAlign: "center",
    },
   
    {
      title: "Quantity",
      width: "10%",
      field: "quantity",
      textAlign: "center",
      rowAlign: "center",
    },
    {
      title: "Status",
      width: "10%",
      field: "status",
      textAlign: "center",
      rowAlign: "center",
    },
    // {
    //   title: "Comments",
    //   width: "10%",
    //   field: "comments",
    //   textAlign: "center",
    //   rowAlign: "center",
    // },
    {
      title: "Is Returnable",
      width: "10%",
      field: "isReturnable",
      isCondition: true,
      textAlign: "center",
      rowAlign: "center",
    },
    {
      title: "Approved By",
      width: "10%",
      field: "approvedByName",
      textAlign: "center",
      rowAlign: "center",
    },
    {
      title: "Issueed By",
      width: "10%",
      field: "issueedByName",
      textAlign: "center",
      rowAlign: "center",
    },
    {
      title: "Prepared By",
      width: "10%",
      field: "preparedByName",
      textAlign: "center",
      rowAlign: "center",
    },
    {
      title: "Reviewed By",
      width: "10%",
      field: "reviewedByName",
      textAlign: "center",
      rowAlign: "center",
    },
    {
      title: "Action",
      width: "5%",
      field: "action",
      textAlign: "center",
      rowAlign: "center",
      contents:{
        // fetcher:getData,
        id:"requestId",
        removeValue:"requestFor",
        url:`/requests/`,
        moduleName:"Requests",
        from:`/main/${officeId}/store/requests`,
        editLink:`/main/${officeId}/store/requests/edit/`,
        viewLink:`/main/${officeId}/store/requests/view/`
      }
    },
  ];
  useEffect(()=>{
    setParams({...params,page:page,per_page:pageCount})
   },[page,pageCount])
  const closeFilterDialog = () => {
    setShowFilterDialog(false);
  };
 
  const [showEdit, setShowEdit] = useState(false)
  const [showDelete, setShowDelete] = useState(false)
  const [listofNumbers, setListofNumbers] = useState([])
  const [fullList, setFullList] = useState([])

  const selectOneFunction = (value) =>{ 
    let NewId;
    if(listofNumbers && listofNumbers.some(Item=>Item ===value)){
      NewId = listofNumbers.filter(Temp=> Temp !== value);
      setListofNumbers(NewId)
    }else{
      setListofNumbers([...listofNumbers,value])
    }
  }

  const selectMultipleFunction = (e) =>{ 
console.log(e.target.checked);
if(e.target.checked){
  setListofNumbers(fullList)
}else{
  setListofNumbers([])
}

  }

  useEffect(()=>{
    let tempArr = []
    data && data.forEach(i=>{
      console.log("I",i?.requestId);
      tempArr.push(i?.requestId)
    });
    setFullList(tempArr)
  },[data])

  const [valueOfSearch,setValuesofSearch] = useState("")
  function searchFunction(e) {

    
    setValuesofSearch(e?.target?.value)
    setParams({ ...params, search: e?.target?.value, page:1 });
    setPage(1)
  }
 
 return (
   <>
   <StoreLayout 
   //  setOpen={closeModal}
   searchFun={searchFunction}
   searchValue={valueOfSearch}
    getData={getData}
    isFilter={filter}
    select={true}

     setFilterOpen={setShowFilterDialog}
     ClearFilter={clearFilter}
     CreateAccess={GetAccess("requests_create")}
    //  ImportAccess={GetAccess("purchase_request_create")}
     officeId={officeId}
     // projectId={projectId}
       >
          {
  screenSize.width <= "786" ?(<>
  <div className=' w-full h-[calc(100vh-160px)] bg-white mt-1 rounded-lg shadow-lg overflow-hidden'>
  <MobileIndex
  data={data}
  total={totalCount}
  pageIndex={page}
  setPageIndex={setPage}
  dataCount={pageCount}
  setDataCount={setPageCount}
  officeId={officeId}
  getData={getData}

  />
  </div>
  </>):(<>
    <div className="w-full h-full ">
    

      <CustomDataTable
      fetcher={getData}
        data={data} 
        availableHeaders={availableHeaders} 
        defaultHeader={defaultHeaders}
       bodyHeight="max-h-[calc(100vh-260px)]"
        height="h-[calc(100vh-145px)]"
        total={totalCount}
        pageIndex={page}
        setPageIndex={setPage}
        dataCount={pageCount}
        setDataCount={setPageCount}
        // title='Requests List'
        storageName="RequestTable"
        selectOneFunction={selectOneFunction}
        setShowDelete={setShowDelete}
        showDelete={showDelete}
        setShowEdit={setShowEdit}
        showEdit={showEdit}
        listofNumbers={listofNumbers}
        hasMultiEdit={true}
        selectMultipleFunction={selectMultipleFunction}
        fullList={fullList}
        getById="requestId" 
         editAccess="requests_edit"      
        deteleAccess="requests_delete" 
        dataLoading={dataLoading}
        searchQuery={params?.search!=""?params?.search:""}

        />
        </div>
        </>)
      }
        </StoreLayout>
          {showFilterDialog && (
             
             
             <div className="fixed top-0 left-0 w-full h-full bg-gray-800 bg-opacity-50 z-[9999] flex justify-center items-center">
               <div className="animate-scale-in min-w-[40%] max-w-[80%] max-h-[80vh] bg-white py-4 px-6 rounded-md shadow-lg overflow-y-scroll">
                 <h2 className="text-xl mb-4">Filter Request</h2>
                 <form onSubmit={formik.handleSubmit}> 
                 <div className="flex flex-col mb-4">
                 <FormikSelectTwo
              type="text"
              label="Status"
              placeholder="Choose"
              Options={RequestStatus}
              formik={formik}
              name="status"
              width="w-full "
            />  
             <FormikSelectTwo
              type="text"
              label="Approval Status"
              placeholder="Choose"
              Options={ApprovalStatus}
              formik={formik}
              name="approvalStatus"
              width="w-full "
            />      
                 <FormikSelectTwo
                      type="text"
                      label="Is Returnable"
                      placeholder="Choose"
                      Options={[
                        { value: true , label: "Yes"},
                        { value: false , label: "No"},
                      ]}
                      formik={formik}
                      name="isReturnable"
                      width="w-full "
                    
                    />
                            
                    </div>
                   <div className="flex justify-end gap-2">
                     <CancelButton handleClick={closeFilterDialog} />
                     <SubmitButton name='Apply' />
                   </div>
                  </form> 
               </div>
             </div>
           )}
                              {showEdit && (<MultiEditRequest data={listofNumbers} getData={getData} onClose={()=>setShowEdit(false)}/>)}
        <ModalContainer
                visiable={showDelete}
                title="Warning"
                content={`Are you sure, All selected datas will be removed from YPR List!`}
                handleClick={() =>{}}
                closeModal={() => setShowDelete(false)}
            />
    </>
  );
}

export default RequestIndex;
